import { render, staticRenderFns } from "./telphone.vue?vue&type=template&id=13598b94&scoped=true&"
import script from "./telphone.vue?vue&type=script&lang=js&"
export * from "./telphone.vue?vue&type=script&lang=js&"
import style0 from "./telphone.vue?vue&type=style&index=0&id=13598b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13598b94",
  null
  
)

export default component.exports